<template>
  <div class="page flex">
    <app-header class="header flex0" ref="header" title="常用就诊人">
      <i slot="back"></i>
      <div class="right" slot="right" @click="del">删除</div>
    </app-header>
    <div class="main overflow-y-auto" ref="main">
      <div class="auth wrap flex" @click="handleRealName(compatInfo.isRealnameAuth)">
        <div class="label flex0">
          实名认证
        </div>
        <div class="text flex1">
          <span :class="[compatInfo.isRealnameAuth?'ok':'no']">{{ compatInfo.isRealnameAuth | isAuth }}</span>
        </div>
      </div>

      <div class="title">
        个人信息
      </div>

      <div class="wrap flex" @click="edit('name',compatInfo.compatName)">
        <div class="label flex0">
          姓名
        </div>
        <div class="text flex1">
          {{ compatInfo.compatName }}
        </div>
      </div>

      <div class="wrap flex" @click="edit('card',compatInfo.compatIdcard)">
        <div class="label flex0">
          身份证
        </div>
        <div class="text flex1">
          {{ compatInfo.compatIdcard|formatCardAndMobile(3,4,12) }}
        </div>
      </div>

      <div class="wrap flex" @click="toMobileChangePage">
        <div class="label flex0">
          院内预留手机号
        </div>
        <div class="text flex1">
          {{ compatInfo.compatMobile|formatCardAndMobile(3,4,4) }}
        </div>
      </div>

      <div class="wrap flex nobg">
        <div class="label flex0">
          年龄
        </div>
        <div class="text flex1">
          {{ compatInfo.compatAge }}
        </div>
      </div>

      <div class="wrap flex nobg">
        <div class="label flex0">
          性别
        </div>
        <div class="text flex1">
          {{ compatInfo.compatGender | getGender }}
        </div>
      </div>

      <div class="wrap flex" @click="modifyMaritalStatus">
        <div class="label flex0">
          婚姻状况
        </div>
        <div class="text flex1">
          {{ compatInfo.maritalStatus|getMaritalStatus }}
        </div>
      </div>

      <div @click="area" class="wrap flex">
        <div class="label flex0">
          所在地区
        </div>
        <div class="text flex1">
          {{ compatInfo.areaName }}
        </div>
      </div>

      <div class="wrap flex" @click="ship">
        <div class="label flex0">
          与我关系
        </div>
        <div class="text flex1">
          {{ compatInfo.relationship }}
        </div>
      </div>

      <div class="wrap flex" @click="goHisInfo">
        <div class="label flex0">
          院内建档信息
        </div>
        <div class="text flex1"></div>
      </div>

      <div class="title">
        医院信息
      </div>

      <div v-for="hos in compatInfo.records" class="wrap flex nobg" @click="handlerRecord(hos)">
        <div class="label">
          {{ hos.hosName }}
        </div>
        <div class="text flex1">({{ hos.compatMedicalRecord ? hos.compatMedicalRecord : "" }})</div>
      </div>
      <div class="wrap flex nobg">
        <router-link :to="{path:'/hospital',query:{action:'auth',compatId:compatInfo.compatId}}"
                     class="add flex1 center">+添加医院账号
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "../../plugins/app-header.vue"
import api from '../../lib/api'
import weui from 'weui.js'
import {formatCardAndMobile, getGender, getMaritalStatus, isAuth} from "../../lib/filter"
import {mainHeightMixin} from "../../lib/mixin"
import {MAIN_COLOR, maritalStatus, relationship} from "../../lib/config"
import getArea from "../../utils/formatArea"
import {RecordMixin} from "../../lib/mixins/record";
import {Dialog} from "vant";
import {userService} from "@/services/user";


export default {
  data() {
    return {
      compatInfo: {},
      index: 0
    }
  },
  computed: {},
  created() {
    this.$route.query.index && (this.index = this.$route.query.index);
    this.getCompatInfo();
  },
  watch: {
    'compatInfo.areaCode': {
      handler(newV) {
        getArea(newV, 'text').then(data => this.$set(this.compatInfo, 'areaName', data));
      }
    }
  },
  methods: {
    goHisInfo() {
      if (!this.compatInfo.compatMedicalRecord) return Dialog.confirm({
        message: '该就诊人没有绑定病案号，是否绑定？',
        confirmButtonText: '绑定',
        confirmButtonColor: MAIN_COLOR,
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$router.push({
            path: '/hospital',
            query: {action: 'auth', compatId: this.compatInfo.compatId}
          });
        }).catch(() => {
        })
      this.$router.push({
        path: '/my/hisaddr/edit',
        query: {compatId: this.compatInfo.compatId, title: '院内建档信息', type: 'modify'}
      });
    },
    dialog() {
      weui.alert("<p class='center'><i class='weui-icon-warn weui-icon-size70'></i></p><br>" +
        "您已通过实名认证，无法修改姓名、身份证号", {
        buttons: [
          {
            label: "我知道了",
            type: "primary"
          }
        ]
      })
    },
    edit(type, value) {
      if (this.compatInfo.isRealnameAuth) {
        return this.dialog();
      }
      this.$router.push({
        path: "/my/edit",
        query: {
          service: "nethos.pat.compat.modify.v2",
          mode: type,
          value: value,
          id: this.compatInfo.compatId
        }
      })

    },
    toMobileChangePage() {
      Dialog.confirm({
        message: '是否修改院内预留手机号',
        confirmButtonText: '去修改',
        confirmButtonColor: MAIN_COLOR
      }).then(() => {
        this.$router.push({
          path: "/account/modify/default/phone",
          query: {
            type: 'modify',
            compatId: this.compatInfo.compatId
          }
        })
      });
    },
    async getCompatInfo() {
      const list = await this.$store.dispatch('getCompatList', {});
      if (list.length) {
        this.compatInfo = list[this.index] || {};
        if (!this.compatInfo.areaName && this.compatInfo.areaCode) await this.$set(this.compatInfo, 'areaName', await getArea(this.compatInfo.areaCode, 'text'))
      } else {
        weui.alert(data.msg);
      }
    },
    handleRealName(auth) {
      let path = "/my/auth", query = {
        compatId: this.compatInfo.compatId
      }
      this.$router.push({path, query});
    },
    async modify(form) {
      let loading = weui.loading("修改中...");
      let options = {
        compatId: this.compatInfo.compatId
      }
      options = Object.assign({}, options, form);
      let ret = await api("nethos.pat.compat.modify.v2", options);
      loading.hide();
      if (ret.code == 0) {
        let userInfo = Object.assign({}, this.compatInfo, ret.obj);
        this.compatInfo = userInfo;
        setTimeout((res) => {
          weui.toast("修改成功");
        }, 200)
      }

    },
    ship() {
      let menus = relationship.map((item) => {
        return {
          label: item,
          onClick: () => {
            this.modify({
              relationship: item
            })
          }
        }
      })

      weui.actionSheet(menus, [
        {
          label: '取消',
          onClick: () => {
          }
        }
      ]);


    },
    async area() {
      let that = this;
      let container = "body", list = await getArea(), defaultValue = this.compatInfo.areaCode;
      defaultValue && (defaultValue = await getArea(this.compatInfo.areaCode, 'code'))
      let options = {
        container,
        defaultValue,
        onConfirm(arr) {
          that.modify({
            areaCode: arr[2].value
          })
        }
      }
      weui.picker(list, options)
    },
    del() {
      let that = this;
      weui.confirm("是否删除该常用就诊人?", () => {
        that.delete()
      })
    },
    async delete() {
      let loading = weui.loading("加载中...")
      let compatId = this.compatInfo.compatId, ret = await api("nethos.pat.compat.delete", {compatId})
      loading.hide();
      if (ret.code == 0) {
        setTimeout(() => {
          weui.toast("删除成功")
        }, 500)
        this.$router.go(-1);
      } else {
        setTimeout((res) => {
          weui.alert(ret.msg);
        }, 500)

      }
    },
    modifyMaritalStatus() {
      this.$weuijs.picker(maritalStatus, {
        container: 'body',
        onConfirm: (arr) => {
          console.log('arr', arr);
          this.modify({
            maritalStatus: maritalStatus.findIndex(r => r === arr[0].value)
          })
        }
      });
    }
  },
  mixins: [mainHeightMixin, RecordMixin],
  filters: {
    getMaritalStatus, isAuth, getGender, formatCardAndMobile
  },
  components: {
    AppHeader,
  }
}
</script>
<style scoped lang="scss">
@import "../../common/public";

%column {
  flex-direction: column;
}

.page {
  @extend %column;

  .wrap + .wrap {
    @include border(top);
  }

  .auth {
    .ok {
      color: $mainColor;
    }

    .no {
      color: red;
    }
  }

  .title {
    background-color: $bgColor;
    padding: 10px 1rem;
  }

  .wrap {
    background-image: url("../../../static/img/more.png");
    @include backgroundImageSet(17px/2, 30px/2, 19rem);
    padding: 15px 1.5rem 15px 1rem;
    align-items: center;
    line-height: 1;

    &.nobg {
      background: none;
    }

    .label {
      font-size: 17px;
    }

    .text {
      text-align: right;
      color: #999999;

      img {
        border-radius: 50%;
        @include w_h(40px, 40px);
      }
    }

    .add {
      color: $mainColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/detailUsual.vue